import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
// Импортируем функцию проверки токена из утилит (из предыдущего шага)
import { isAuthenticated } from '../utils/auth';

const LoginPage = () => {
    const [name, setName] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    // ✅ Автоматический редирект, если пользователь уже авторизован
    useEffect(() => {
        if (isAuthenticated()) {
            navigate('/dashboard', { replace: true });
        }
    }, [navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');

        try {
            const API_URL = process.env.NODE_ENV === 'production'
                ? ''
                : 'http://localhost:5022';

            const response = await axios.post(`${API_URL}/api/auth/login`, {
                name,
                password,
            });

            localStorage.setItem('token', response.data.token);
            localStorage.setItem('userInfo', JSON.stringify({
                name: response.data.name,
                levelRight: response.data.levelRight,
                groupNum: response.data.groupNum,
                description: response.data.description,
                canChangeHousesYY: response.data.canChangeHousesYY,
                canChangeComments: response.data.canChangeComments,
                canChangeObjectsGroups: response.data.canChangeObjectsGroups,
            }));

            navigate('/dashboard');
        } catch (err) {
            // Если сервер вернул 401 (Неверный логин или пароль), err.response.status будет 401
            setError(err.response?.data?.message || 'Ошибка подключения к серверу');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 p-4">
            <div className="bg-white/10 backdrop-blur-lg border border-white/20 rounded-2xl shadow-2xl p-8 w-full max-w-md">

                {/* Логотип / Заголовок */}
                <div className="text-center mb-8">
                    <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-gradient-to-br from-blue-600 to-blue-800 mb-4 shadow-lg shadow-blue-500/50 ring-4 ring-blue-400/20 transition-transform hover:scale-105">
                        {/* SVG Логотип Аксиома-КС */}
                        <svg
                            version="1.0"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 110.000000 110.000000"
                            preserveAspectRatio="xMidYMid meet"
                            className="w-16 h-16"
                        >
                            <g transform="translate(10.000000,95.000000) scale(0.080000,-0.080000)"
                                fill="#FFFFFF" stroke="none">
                                <path d="M618 957 c-20 -29 -84 -118 -142 -199 l-105 -148 109 0 109 0 42 55 c23 30 45 55 50 55 5 0 9 -25 9 -55 l0 -55 85 0 85 0 0 200 0 200 -102 0 -103 -1 -37 -52z" />
                                <path d="M152 508 c-80 -110 -84 -118 -70 -123 7 -2 34 -6 61 -7 l47 -3 -85 -124 c-47 -69 -85 -128 -85 -133 0 -5 48 -7 107 -6 l106 3 92 130 91 130 272 3 271 2 56 76 c31 41 59 82 62 90 4 12 -58 14 -441 14 l-445 0 -39 -52z" />
                                <path d="M694 331 c-2 -2 -4 -53 -4 -113 l0 -108 85 0 85 0 0 110 c0 61 -3 110 -7 110 -52 4 -156 4 -159 1z" />
                            </g>
                        </svg>
                    </div>
                    <h1 className="text-3xl font-bold text-white tracking-wide">Аксиома-КС</h1>
                    <p className="text-blue-200 mt-2 text-sm">Система диспетчеризации узлов учета</p>
                </div>

                {/* Форма */}
                <form onSubmit={handleSubmit} className="space-y-6">
                    {error && (
                        <div className="bg-red-500/20 border border-red-500/50 text-red-200 px-4 py-3 rounded-lg text-sm flex items-center animate-fade-in">
                            <svg className="w-5 h-5 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <span>{error}</span>
                        </div>
                    )}

                    <div>
                        <label className="block text-blue-100 text-sm font-medium mb-2">Логин</label>
                        <input
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            // ✅ Улучшение UX для менеджеров паролей и автофокус
                            autoComplete="username"
                            autoFocus
                            className="w-full px-4 py-3 bg-slate-800/50 border border-slate-600 rounded-lg text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                            placeholder="Введите имя пользователя"
                            required
                        />
                    </div>

                    <div>
                        <label className="block text-blue-100 text-sm font-medium mb-2">Пароль</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            // ✅ Улучшение UX для менеджеров паролей
                            autoComplete="current-password"
                            className="w-full px-4 py-3 bg-slate-800/50 border border-slate-600 rounded-lg text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                            placeholder="Введите пароль"
                            required
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={isLoading}
                        className="w-full bg-blue-600 hover:bg-blue-500 text-white font-semibold py-3 px-4 rounded-lg shadow-lg shadow-blue-600/30 transition-all duration-200 transform hover:scale-[1.02] disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                    >
                        {isLoading ? (
                            <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                        ) : (
                            'Войти в систему'
                        )}
                    </button>
                </form>

                <div className="mt-6 text-center text-slate-400 text-xs">
                    © {new Date().getFullYear()} Группа предприятий Аксиома. Все права защищены.
                </div>
            </div>
        </div>
    );
};

export default LoginPage;